import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=215d327b&scoped=true&"
import script from "./testPaper.vue?vue&type=script&lang=js&"
export * from "./testPaper.vue?vue&type=script&lang=js&"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=215d327b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d327b",
  null
  
)

export default component.exports